// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-notice-index-__index__banner","con_r":"app__css__app-pages-notice-index-__index__con_r","item":"app__css__app-pages-notice-index-__index__item","time":"app__css__app-pages-notice-index-__index__time"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/notice/index/index.css
// module id = 1579
// module chunks = 0